// extracted by mini-css-extract-plugin
export default {"container":"EmailShare_container__R5Rc-","shareEmailBtn":"EmailShare_shareEmailBtn__jHprl","emailSvg":"EmailShare_emailSvg__CoTzQ"};